const combineChunks = (chunks) => {
	chunks.sort((a, b) => a.sequence - b.sequence);
	const combinedData = chunks.map((chunk) => chunk.data).join('');
	return combinedData;
};

export const parseJsonOrString = (data) => {
	try {
		return JSON.parse(data);
	} catch (e) {
		return data;
	}
};

/**
 *
 * @param {object} data
 * @param {React.Ref} receivedChunksByGroupRef
 * @returns {object}
 */
export const handleChunkWithGrouping = (data, receivedChunksByGroupRef) => {
	if (data.chunkGroupId) {
		if (!receivedChunksByGroupRef.current[data.chunkGroupId]) {
			receivedChunksByGroupRef.current[data.chunkGroupId] = [];
		}

		receivedChunksByGroupRef.current[data.chunkGroupId].push(data);

		const totalChunksForGroup = data.totalChunks;
		const receivedChunksForGroup = receivedChunksByGroupRef.current[data.chunkGroupId];

		if (receivedChunksForGroup.length !== totalChunksForGroup) {
			return null;
		}

		const reassembledContent = combineChunks(receivedChunksForGroup);
		delete receivedChunksByGroupRef.current[data.chunkGroupId];

		return parseJsonOrString(reassembledContent);
	} else {
		return parseJsonOrString(data);
	}
};
